import {
  PromptForMissingDatasource,
  PromptForMissingFieldValue,
} from 'src/shared/PromptForMissingDatasource';
import { C25LocationInfoProps } from './C25LocationInfo.types';
import { CreateLocationInfoModel } from './C25LocationInfo.service';
import { useCustomSitecoreContext } from 'src/shared/useCustomSitecoreContext';
import { LocationInfo } from '@ahc-digital/component-library';
import { translationClasses } from 'src/shared/TranslationClasses';

export const Default = (props?: C25LocationInfoProps): JSX.Element => {
  const context = useCustomSitecoreContext();
  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  if (Object.keys(props?.fields?.Location?.fields || {}).length === 0)
    return <PromptForMissingFieldValue fieldName={'Location'} rendering={props?.rendering} />;

  return (
    <LocationInfo
      {...CreateLocationInfoModel(props, context?.envVariableNameForGoogleMapAPI?.value)}
      className={translationClasses(props?.params)}
    />
  );
};
